import * as angular from 'angular';
import './ruleItem.scss';
import { RuleUtilsService } from '../../services/RuleUtilsService';
import { RulesConstants, RulesTracks } from '../../RulesConstants';
const STATES = RulesConstants.STATES;
export class RuleItemController {
    static $inject = ['SegmentService', '$translate', 'ngToast'];
    constructor(SegmentService, $translate, ngToast) {
        'ngInject';
        this.SegmentService = SegmentService;
        this.$translate = $translate;
        this.ngToast = ngToast;
        this.elementId = 'rule';
        this.builderSource = RulesTracks.SOURCE.BUILDER;
        this.onToggleRule = async () => {
            this.data.isActive = !this.rule.isActive;
            const trackName = this.data.isActive ? RulesTracks.RULE_ENABLED : RulesTracks.RULE_DISABLED;
            this.SegmentService.createBotTrack(trackName, this.application, this.trackPayload);
            this.isLoading = true;
            await this.onToggle({ $rule: this.data });
            this.isLoading = false;
        };
        this.onChangeOperator = async (event) => {
            if (!this.canEditRule) {
                const errorMsg = await this.$translate('attendance-rules.errors.cannotEdit');
                this.ngToast.danger(errorMsg);
                this.rule = angular.copy(this.data);
                this.rule.repeatConditionsBody = this.rule.conditions.length > 1;
                return;
            }
            if (event?.detail?.value && this.rule.operator !== event.detail.value) {
                this.rule.operator = event.detail?.value;
                this.expandableBodyText = await this.translateOperator();
                this.operatorText = await this.translateOperatorText();
            }
        };
        this.onChangeTeam = async (event) => {
            if (!this.canEditRule) {
                const errorMsg = await this.$translate('attendance-rules.errors.cannotEdit');
                this.ngToast.danger(errorMsg);
                this.rule = angular.copy(this.data);
                this.rule.repeatConditionsBody = this.rule.conditions.length > 1;
                return;
            }
            if (!event || this.rule.operator === event.detail?.value) {
                return;
            }
            else {
                this.rule.team = event.detail?.value;
                this.rule.queueId = undefined;
            }
        };
        this.changeTitle = (event) => {
            const title = event?.detail?.value ?? '';
            this.rule.title = title;
        };
        this.showNoPermissionAlert = async () => {
            this.ngToast.warning(this.$translate.instant('attendance-rules.errors.cannotEdit'));
        };
    }
    async $onInit() {
        this.rule = angular.copy(this.data);
        this.expandableBodyText = await this.translateOperator();
        this.operatorText = await this.translateOperatorText();
        this.rule.valuesEmpty = this.isAnyValueEmpty();
        this.trackPayload = {
            source: this.isManagerView ? RulesTracks.SOURCE.PORTAL : RulesTracks.SOURCE.BUILDER,
        };
    }
    $editModel() {
        this.rule = angular.copy(this.data);
        this.rule.conditions = this.rule.conditions.map(condition => {
            const prop = RuleUtilsService.convertExtras(condition.property);
            condition.property = prop;
            return condition;
        });
        this.currentState = STATES.EDITING;
        this.rule.valuesEmpty = this.isAnyValueEmpty();
    }
    $deleteModel() {
        if (!this.canEditRule) {
            return;
        }
        this.onDelete({ $item: this.rule });
    }
    $cancelModel() {
        this.onCancel();
        this.data.opened = false;
        this.rule = angular.copy(this.data);
    }
    onOpenRuleChild() {
        this.rule.opened = true;
        this.data = this.rule;
        this.onOpenRule();
        this.rule = angular.copy(this.data);
        if (!this.canEditRule) {
            this.showNoPermissionAlert();
        }
    }
    async updateRule() {
        try {
            if (this.onSave) {
                await this.onSave({ $rule: this.rule });
            }
        }
        catch (e) {
            this.ngToast.warning(this.$translate.instant('modules.application.detail.attendance.rules.warning'));
        }
        finally {
            this.rule.opened = false;
            this.isLoading = false;
        }
    }
    async translateOperator() {
        return this.operators.find(op => op.value === this.rule.operator).label || '';
    }
    async translateOperatorText() {
        if (this.rule.operator === 'Or') {
            return await this.$translate('modules.application.detail.attendance.rules.conditionsHeaderTextOr');
        }
        else if (this.rule.operator === 'And') {
            return await this.$translate('modules.application.detail.attendance.rules.conditionsHeaderTextAnd');
        }
    }
    async addCondition() {
        this.rule.repeatConditionsBody = true;
        this.rule.operator = this.rule.operator || RulesConstants.DEFAULT_OPERATOR;
        this.expandableBodyText = await this.translateOperator();
        this.rule.conditions[this.rule.conditions.length] = {
            property: 'Message',
            relation: 'Contains',
            values: [],
            extrasProperty: '',
        };
        this.rule.valuesEmpty = this.isAnyValueEmpty();
        this.SegmentService.createBotTrack(RulesTracks.CONDITION_ADDED, this.application, this.trackPayload);
    }
    async removeCondition(conditionIndex) {
        this.rule.operator = this.rule.operator ?? RulesConstants.DEFAULT_OPERATOR;
        await this.rule.conditions.splice(conditionIndex, 1);
        this.rule.conditions = this.rule.conditions.filter(val => val);
        this.rule.repeatConditionsBody = this.rule.conditions.length > 1;
        const trackConditionDeleted = this.source === this.builderSource ? RulesTracks.BUILDER_CONDITION_DELETED : RulesTracks.CONDITION_DELETED;
        this.SegmentService.createBotTrack(trackConditionDeleted, this.application, this.trackPayload);
    }
    async updateCondition(condition, index) {
        this.rule.conditions[index] = condition;
        this.rule.operator = this.rule.operator ?? RulesConstants.DEFAULT_OPERATOR;
        this.rule.valuesEmpty = this.isAnyValueEmpty();
    }
    isAnyValueEmpty() {
        return !this.rule.conditions.every(condition => {
            return condition.property.includes('Extras')
                ? condition.property && condition.extrasProperty && condition.relation && condition.values.length && this.rule.title
                : condition.property && condition.relation && condition.values.length && this.rule.title;
        });
    }
}
RuleItemController.$inject = ['SegmentService', '$translate', 'ngToast'];
